import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

export const HideOnMobile = styled.div`
  display: block;

  ${({ height }) => height && `height: ${height};`}
  ${({ width }) => width && `width: ${width};`}

  ${mediaQueries.tablet`
    display: none;
  `};
`

export const WrapperLink = styled.div`
  ${({ disabled }) =>
    disabled &&
    `
    opacity: .6;
    cursor: no-drop;
   `}
`
export const AddLink = styled.button.attrs(props => ({
  className: props.e2eClass
}))`
  border: none;
  background: none;
  font-size: 14px;
  margin: 10px 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
  width: ${({ width }) => (width ? width : '100%')};
  height: ${({ height }) => (height ? height : '')};
  text-align: center;
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
   `}

  ${mediaQueries.mobile`
    text-align: left;
  `};
`

export const RemoveLinkInRow = styled.label.attrs(props => ({
  className: props.e2eClass
}))`
  position: relative;
  transform: translate(0, 120%);
  font-size: 14px;
  margin: 10px 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
  width: ${({ width }) => (width ? width : '100%')};
  text-align: center;

  ${mediaQueries.mobile`
    text-align: left;
  `};
`

export const UnderlineText = styled.label`
  cursor: pointer;
  margin-left: 5px;
  text-decoration: underline;
`

export const DashedSeparator = styled.div`
  border-bottom: 1px dashed ${({ theme, color }) => color || theme.colors.doveGray};
  width: 100%;
  ${({ nomargin }) => !nomargin && `margin-bottom: 20px`};
  ${({ hide }) => hide && `display: none;`};
`

export const ErrorContainer = styled.div.attrs(props => ({
  className: `${props.name}-error`
}))`
  padding: 6px 0;

  ${mediaQueries.tablet`
    padding: 0;
    margin-top: 14px;
  `};
`
